import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Form, Input, Button, message, Avatar } from 'antd';
import { ArrowLeftOutlined, UserOutlined } from '@ant-design/icons';
import { updateUser } from '../api/auth';
import { getUserInfo, updateUserInfo } from '../utils/auth';
import { useI18n } from '../i18n/I18nContext';
import './UserProfile.css';

function UserProfile() {
  const navigate = useNavigate();
  const { t, locale } = useI18n();
  const user = getUserInfo();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const updateData = {};
      if (values.name) updateData.name = values.name;
      if (values.password) updateData.password = values.password;

      const response = await updateUser(user.id, updateData);
      if (response.success) {
        message.success(t('toast.updateSuccess'));
        updateUserInfo(response.user);
        form.resetFields(['password', 'confirmPassword']);
      }
    } catch (error) {
      console.error('更新失败:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="profile-container">
      <div className="profile-header-bar">
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/')}
          className="back-button"
        >
          {t('profile.backHome')}
        </Button>
      </div>

      <Card className="profile-card" title={t('profile.title')}>
        <div className="avatar-section">
          <Avatar size={100} icon={<UserOutlined />} className="large-avatar" />
          <p className="username">{user?.username}</p>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{ name: user?.name }}
          className="profile-form"
          key={locale}
        >
          <Form.Item label={t('profile.username')}>
            <Input disabled value={user?.username} />
          </Form.Item>

          <Form.Item
            label={t('profile.nickname')}
            name="name"
            rules={[{ required: true, message: t('profile.nameRequired') }]}
          >
            <Input placeholder={t('profile.namePlaceholder')} />
          </Form.Item>

          <Form.Item
            label={t('profile.newPassword')}
            name="password"
            rules={[{ min: 6, message: t('profile.passwordMin') }]}
          >
            <Input.Password placeholder={t('profile.passwordPlaceholderLeaveBlank')} />
          </Form.Item>

          <Form.Item
            label={t('profile.confirmPassword')}
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t('login.passwordMismatch')));
                },
              }),
            ]}
          >
            <Input.Password placeholder={t('profile.confirmPlaceholder')} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block size="large">
              {t('profile.save')}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default UserProfile;
